module.exports = __webpack_public_path__ + "img/Retail7.d5870fa2.png";